import { Component, Input } from '@angular/core';

import { MessageSender } from '../../../shared/models/misc.model';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';

@Component({
  selector: 'app-task-actions-modal',
  templateUrl: './select-reply-to-modal.component.html',
  styleUrls: ['./select-reply-to-modal.component.scss'],
})
export class SelectReplyToModalComponent extends AbstractModalWithResult<void> {
  static modalId = 'SelectReplyToModalComponent';

  @Input() replyToList: MessageSender[];

  getModalId() {
    return SelectReplyToModalComponent.modalId;
  }

  handleOrName(user: MessageSender) {
    return user.handle ? user.handle : user.name;
  }
}
